// @ts-nocheck
import { PATH_DASHBOARD, PATH_MOBILE } from "../routes/paths";
import { StyleSheet } from "@react-pdf/renderer";
import Label from "../components/Label";
import SvgIconStyle from "../components/SvgIconStyle";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BusinessIcon from "@mui/icons-material/Business";
import ChecklistIcon from "@mui/icons-material/Checklist";
import GroupsIcon from "@mui/icons-material/Groups";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import EngineeringOutlinedIcon from "@mui/icons-material/EngineeringOutlined";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import HandymanOutlinedIcon from "@mui/icons-material/HandymanOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import GppMaybeOutlinedIcon from "@mui/icons-material/GppMaybeOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import PolicyOutlinedIcon from "@mui/icons-material/PolicyOutlined";
export const socketServerUrl = import.meta.env.VITE_SOCKET_URL;
export const serverBaseUrl = import.meta.env.VITE_API_URL;

const getIcon = (name) => (
  <SvgIconStyle
    src={`/static/icons/navbar/${name}.svg`}
    sx={{ width: "100%", height: "100%" }}
  />
);
const getIcon3 = (name) => (
  <LocationOnIcon sx={{ width: "100%", height: "100%" }} />
);
const getIcon4 = (name) => (
  <BusinessIcon sx={{ width: "100%", height: "100%" }} />
);
const getIcon5 = (name) => (
  <ChecklistIcon sx={{ width: "100%", height: "100%" }} />
);
const getIcon6 = (name) => (
  <GroupsIcon sx={{ width: "100%", height: "100%" }} />
);
const getIcon7 = (name) => (
  <ShieldOutlinedIcon sx={{ width: "100%", height: "100%" }} />
);
const getIcon8 = (name) => (
  <ArticleOutlinedIcon sx={{ width: "100%", height: "100%" }} />
);
const getIcon9 = (name) => (
  <EngineeringOutlinedIcon sx={{ width: "100%", height: "100%" }} />
);

export const userStatus = {
  online: "online",
  offline: "offline",
};

export const getStatus = (userId, onlineUsers) =>
  onlineUsers[userId] ? userStatus.online : userStatus.offline;
let months = {
  1: "Jan",
  2: "Feb",
  3: "Mar",
  4: "Apr",
  5: "May",
  6: "Jun",
  7: "Jul",
  8: "Aug",
  9: "Sep",
  10: "Oct",
  11: "Nov",
  12: "Dec",
};
// export const FDate = (date)=>  new Date(date).toDateString();
export const FDate = (date) => {
  let d = new Date(date);
  return d.getDate() + "-" + months[d.getMonth() + 1] + "-" + d.getFullYear();
};

export const screenOptions = { mobileLimit: 990, tabletLimit: 800 };

export const checkIfExpired = (expiryDate) => {
  if (!expiryDate) {
    return false;
  }
  let current = new Date();
  let endDate = new Date(expiryDate);

  current = current / 1000;
  endDate = endDate / 1000;

  if (current >= endDate) {
    return true;
  } else {
    return false;
  }
};

export const jobsiteStatus = {
  0: "Under Construction",
  1: "completed",
};
// Role slugs — match users.role on the backend and roles.slug in the DB.
// SUPERADMIN was previously absent from the FE map; STOREADMIN was defined
// here but never implemented on the BE — both fixed in this migration.
export const userRoles = {
  superadmin: "superadmin",
  admin: "admin",
  builder: "builder",
  subcontractor: "subcontractor",
  employee: "employee",
  officeadmin: "officeadmin",
  supervisor: "supervisor",
} as const;

export type UserRole = (typeof userRoles)[keyof typeof userRoles];

export const userRoleNames: Record<UserRole, string> = {
  superadmin: "Super Admin",
  admin: "Admin",
  builder: "Builder",
  subcontractor: "Subcontractor",
  employee: "Employee",
  // Two words. This is the product-wide fallback, so the run-together form
  // surfaced anywhere an industry had not renamed the role — the invite
  // dropdown, the admin user filter, the requirements grid heading.
  officeadmin: "Office Admin",
  supervisor: "Supervisor",
};
export const commonDocs = [
  "cards",
  "licenses",
  "insurances",
  "workCovers",
  "testTag",
  "ewpCards",
  "workingHeightsCards",
  "professions",
];
export const userDocs: Record<UserRole, string[]> = {
  superadmin: [],
  admin: [],
  builder: ["cards", "insurances", "workCovers", "licenses", "professions", "whs", "ptc"],
  subcontractor: ["cards", "insurances", "workCovers", "licenses", "professions", "ptc"], // signs builder's PTC
  employee: ["cards", "professions"],
  officeadmin: [],
  supervisor: ["cards"],
};

export const skipableDocs: Record<UserRole, Record<string, { name: string }>> = {
  superadmin: {},
  admin: {},
  builder: {},
  subcontractor: {
    // "Work Cover if they have employees" — keep skippable for solo subbies.
    workCovers: { name: "workCoverSkipped" },
  },
  employee: {},
  officeadmin: {},
  supervisor: {},
};

export const commonDocsTable = [
  {
    name: "White/Blue Card",
    tableName: "cards",
  },
  {
    name: "QBCC License",
    tableName: "licenses",
  },
  {
    name: "Public Liability Insurance",
    tableName: "insurances",
  },
  {
    name: "Work Cover",
    tableName: "workCovers",
  },
  {
    name: "Test & Tag",
    tableName: "testTag",
  },
  {
    name: "EWP License",
    tableName: "ewpCards",
  },
  {
    name: "Working Heights License",
    tableName: "workingHeightsCards",
  },
];

const DOC_WHITE_CARD       = { name: "White/Blue Card",                              tableName: "cards" };
const DOC_QBCC_LICENSE     = { name: "QBCC License",                                 tableName: "licenses" };
const DOC_PUBLIC_LIABILITY = { name: "Public Liability Insurance",                   tableName: "insurances" };
const DOC_WORK_COVER       = { name: "Work Cover",                                   tableName: "workCovers" };
const DOC_SWMS             = { name: "SWMS",                                         tableName: "professions" };
const DOC_PTC              = { name: "Period Trade Contract",                        tableName: "userDocs", type: "ptc" };
const DOC_WHS              = { name: "Workplace Health and Safety Management Plan", tableName: "userDocs", type: "whs" };

export const userNewDocs: Record<UserRole, Array<{ name: string; tableName: string; type?: string }>> = {
  superadmin: [],
  admin: [],
  builder: [DOC_WHITE_CARD, DOC_PUBLIC_LIABILITY, DOC_WORK_COVER, DOC_QBCC_LICENSE, DOC_SWMS, DOC_WHS, DOC_PTC],
  subcontractor: [DOC_WHITE_CARD, DOC_PUBLIC_LIABILITY, DOC_WORK_COVER, DOC_QBCC_LICENSE, DOC_SWMS, DOC_PTC],
  employee: [DOC_WHITE_CARD, DOC_SWMS],
  officeadmin: [],
  supervisor: [DOC_WHITE_CARD],
};

const ICONS = {
  mail: getIcon("ic_mail"),
  user: getIcon("ic_user"),
  jobsite: getIcon3(""),
  dashboard: getIcon("ic_dashboard"),
  booking: getIcon("ic_booking"),
  builder: getIcon4(""),
  todo: getIcon5(""),
  team: getIcon6(""),
  safetyDocs: getIcon7(""),
  documents: getIcon8(""),
  jobsiteSwms: getIcon9(""),
  checkIn: <LoginOutlinedIcon sx={{ width: "100%", height: "100%" }} />,
  onSiteNow: <GroupsOutlinedIcon sx={{ width: "100%", height: "100%" }} />,
  apiKeys: <VpnKeyOutlinedIcon sx={{ width: "100%", height: "100%" }} />,
  // The register modules from the navigation blueprint.
  incidents: <ReportProblemOutlinedIcon sx={{ width: "100%", height: "100%" }} />,
  inspections: <FactCheckOutlinedIcon sx={{ width: "100%", height: "100%" }} />,
  risks: <GppMaybeOutlinedIcon sx={{ width: "100%", height: "100%" }} />,
  equipment: <HandymanOutlinedIcon sx={{ width: "100%", height: "100%" }} />,
  training: <SchoolOutlinedIcon sx={{ width: "100%", height: "100%" }} />,
  noticeboard: <CampaignOutlinedIcon sx={{ width: "100%", height: "100%" }} />,
  chemical: <ScienceOutlinedIcon sx={{ width: "100%", height: "100%" }} />,
  safetyPlanning: <PolicyOutlinedIcon sx={{ width: "100%", height: "100%" }} />,
  plans: <CreditCardOutlinedIcon sx={{ width: "100%", height: "100%" }} />,
};

export const documentStyle = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
    backgroundColor: "tomato",
  },
  title: {
    fontSize: 24,
    textAlign: "center",
    fontFamily: "Oswald",
  },
  author: {
    fontSize: 12,
    textAlign: "center",
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    marginLeft: 0,
    marginTop: 0,
    fontWeight: "bold",
    color: "grey",
    fontFamily: "Oswald",
  },
  text: {
    margin: 12,
    marginBottom: 0,
    fontSize: 14,
    textAlign: "justify",
    fontFamily: "Times-Roman",
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: "center",
    color: "grey",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
});

export const arrangeDocIndexes = (sections) => {
  var count = 0;
  sections.map((section) => {
    if (section.title && section.title.length > 0) {
      section.index = ++count;
    }
  });
  return sections;
};

export const periodTradeContract = `
    <p>
    <strong>1. GENERAL PERFORMANCE</strong>
    </p><p>  All Work of the Subcontractor will be performed in a good and workmanlike manner in accordance with the plans and specifications for each job and must comply with all Federal and State laws, codes and regulations and all county and/or municipal ordinances and regulations effective where the work is to be performed under this contract. All permits, fees, taxes, and expenses connected with such compliance are to be paid by the Subcontractor.</p><p><br></p><p>
    </p><p><strong>
    2. INDEPENDENT CONTRACTOR
    </strong></p><p>
    The Builder and Subcontractor agree that the Subcontractor is being hired solely as an Independent Contractor and that neither the Subcontractor, nor his employees shall be deemed to be employees of the Builder.
    </p><p><br></p><p><strong>
    3. TIME
    </strong></p><p>
    The Subcontractor agrees to promptly begin work as soon as notified by the Builder, and to complete the work in a professional and workmanlike manner within a reasonable period of time once work is commenced and in any event by the deadlines established by the Builder in writing. Subcontractor shall cooperate with other trades who are also on the job site so that each reasonably may complete their respective work within the required time frames and Subcontractor shall in any event complete Subcontractor’s work within a time that will allow any other trade whose work depends on the completion of Subcontractor’s work to also timely complete its work. At all times, Subcontractor shall provide competent supervision, a sufficient number of skilled workers and adequate and proper materials to maintain Builder’s work schedule. Subcontractor warrants to Builder that he has all proper and necessary licenses and permits to perform the services contracted for by Builder. If Builder determines that Subcontractor’s work does not conform to the provisions of the Drawings and Specifications, or that the work is not of appropriate quality, Builder shall advise Subcontractor, and if Subcontractor does not correct such defects or errors on Builder’s time table, builder shall have the right to correct the defects and to charge back the Subcontractor the cost of such corrections.</p><p><br></p><p>
    </p><p><strong>
    4. EXTRAS
    </strong></p><p>
    No deviations from the work specified in the contract will be permitted or paid for unless a written extra work or change order is first agreed upon and signed as required.
    </p><p><br></p><p><strong>
    5. ASSIGNMENT
    </strong></p><p>
    No assignment of this subcontract agreement by Subcontractor is permitted without prior written permission from the Builder.</p>
`;
export const wsfPlan = `
    <p>
    <strong>1. GENERAL PERFORMANCE</strong>
    </p><p>  All Work of the Subcontractor will be performed in a good and workmanlike manner in accordance with the plans and specifications for each job and must comply with all Federal and State laws, codes and regulations and all county and/or municipal ordinances and regulations effective where the work is to be performed under this contract. All permits, fees, taxes, and expenses connected with such compliance are to be paid by the Subcontractor.</p><p><br></p><p>
    </p><p><strong>
    2. INDEPENDENT CONTRACTOR
    </strong></p><p>
    The Builder and Subcontractor agree that the Subcontractor is being hired solely as an Independent Contractor and that neither the Subcontractor, nor his employees shall be deemed to be employees of the Builder.
    </p><p><br></p><p><strong>
    3. TIME
    </strong></p><p>
    The Subcontractor agrees to promptly begin work as soon as notified by the Builder, and to complete the work in a professional and workmanlike manner within a reasonable period of time once work is commenced and in any event by the deadlines established by the Builder in writing. Subcontractor shall cooperate with other trades who are also on the job site so that each reasonably may complete their respective work within the required time frames and Subcontractor shall in any event complete Subcontractor’s work within a time that will allow any other trade whose work depends on the completion of Subcontractor’s work to also timely complete its work. At all times, Subcontractor shall provide competent supervision, a sufficient number of skilled workers and adequate and proper materials to maintain Builder’s work schedule. Subcontractor warrants to Builder that he has all proper and necessary licenses and permits to perform the services contracted for by Builder. If Builder determines that Subcontractor’s work does not conform to the provisions of the Drawings and Specifications, or that the work is not of appropriate quality, Builder shall advise Subcontractor, and if Subcontractor does not correct such defects or errors on Builder’s time table, builder shall have the right to correct the defects and to charge back the Subcontractor the cost of such corrections.</p><p><br></p><p>
    </p><p><strong>
    4. EXTRAS
    </strong></p><p>
    No deviations from the work specified in the contract will be permitted or paid for unless a written extra work or change order is first agreed upon and signed as required.
    </p><p><br></p><p><strong>
    5. ASSIGNMENT
    </strong></p><p>
    No assignment of this subcontract agreement by Subcontractor is permitted without prior written permission from the Builder.</p>
`;
export const wirPlan = `
    <p>
    <strong>1. GENERAL PERFORMANCE</strong>
    </p><p>  All Work of the Subcontractor will be performed in a good and workmanlike manner in accordance with the plans and specifications for each job and must comply with all Federal and State laws, codes and regulations and all county and/or municipal ordinances and regulations effective where the work is to be performed under this contract. All permits, fees, taxes, and expenses connected with such compliance are to be paid by the Subcontractor.</p><p><br></p><p>
    </p><p><strong>
    2. INDEPENDENT CONTRACTOR
    </strong></p><p>
    The Builder and Subcontractor agree that the Subcontractor is being hired solely as an Independent Contractor and that neither the Subcontractor, nor his employees shall be deemed to be employees of the Builder.
    </p><p><br></p><p><strong>
    3. TIME
    </strong></p><p>
    The Subcontractor agrees to promptly begin work as soon as notified by the Builder, and to complete the work in a professional and workmanlike manner within a reasonable period of time once work is commenced and in any event by the deadlines established by the Builder in writing. Subcontractor shall cooperate with other trades who are also on the job site so that each reasonably may complete their respective work within the required time frames and Subcontractor shall in any event complete Subcontractor’s work within a time that will allow any other trade whose work depends on the completion of Subcontractor’s work to also timely complete its work. At all times, Subcontractor shall provide competent supervision, a sufficient number of skilled workers and adequate and proper materials to maintain Builder’s work schedule. Subcontractor warrants to Builder that he has all proper and necessary licenses and permits to perform the services contracted for by Builder. If Builder determines that Subcontractor’s work does not conform to the provisions of the Drawings and Specifications, or that the work is not of appropriate quality, Builder shall advise Subcontractor, and if Subcontractor does not correct such defects or errors on Builder’s time table, builder shall have the right to correct the defects and to charge back the Subcontractor the cost of such corrections.</p><p><br></p><p>
    </p><p><strong>
    4. EXTRAS
    </strong></p><p>
    No deviations from the work specified in the contract will be permitted or paid for unless a written extra work or change order is first agreed upon and signed as required.
    </p><p><br></p><p><strong>
    5. ASSIGNMENT
    </strong></p><p>
    No assignment of this subcontract agreement by Subcontractor is permitted without prior written permission from the Builder.</p>
`;

// Admin's nav, shared by both admin and superadmin. Superadmin sees
// everything an admin does (the only superadmin-specific affordance lives
// inside the user dialog: set/unset Admin). Defined once and reused below so
// the two never drift apart.
const adminMenu = {
  subheader: "Admin",
  items: [
    {
      title: "Overview",
      path: PATH_DASHBOARD.admin.overview,
      icon: ICONS.dashboard,
    },
    {
      title: "Documents",
      path: PATH_DASHBOARD.documentsIndex,
      icon: ICONS.documents,
      children: [
        { title: "PTC", path: PATH_DASHBOARD.ptcDocument },
        { title: "WHS", path: PATH_DASHBOARD.whsDocument },
        { title: "SWMS", path: PATH_DASHBOARD.swmsDocument },
        {
          title: "High Risk Activities",
          path: PATH_DASHBOARD.hrwaDocument,
        },
        {
          title: "Hazardous Substances",
          path: PATH_DASHBOARD.hazardousSubstances,
        },
        {
          title: "Terms & Conditions",
          path: PATH_DASHBOARD.termsAndConditions,
        },
      ],
    },
    {
      title: "users",
      path: PATH_DASHBOARD.admin.users,
      icon: ICONS.user,
    },
    {
      title: "teams",
      path: PATH_DASHBOARD.admin.teams,
      icon: ICONS.team,
    },
    {
      // "Workplaces", not "Job Sites". An admin's list holds a building site, a
      // cafe and a warehouse at once, so there is no industry whose word is
      // correct — and the owner-side rename that turns this into "Venues" reads
      // the viewer's OWN industry, which for an admin is the wrong question
      // entirely. Neutral is the only honest answer at this scope.
      title: "Workplaces",
      path: PATH_DASHBOARD.admin.jobsites,
      icon: ICONS.jobsite,
    },
    {
      title: "Document Templates",
      path: PATH_DASHBOARD.admin.businessTypeRequirements,
      icon: ICONS.documents,
    },
    {
      // The queue behind "Choose plan". Requests land here rather than in an
      // inbox, so one can be tracked to a conclusion.
      title: "Subscription requests",
      path: PATH_DASHBOARD.admin.subscriptionRequests,
      icon: ICONS.plans,
    },
    {
      title: "Message Templates",
      path: PATH_DASHBOARD.admin.templates,
      icon: ICONS.mail,
    },
    {
      // Construction's own tooling, named as such. Pool Types and Construction
      // Types are QBCC categories that mean nothing to a venue or a warehouse,
      // and presenting them as part of the product's spine is what made the
      // admin dashboard read as construction-only. Grouping them under the
      // industry they belong to keeps them reachable without implying they
      // apply to everybody.
      title: "Construction tools",
      path: PATH_DASHBOARD.jobsiteSwms,
      icon: ICONS.jobsiteSwms,
      children: [
        { title: "Site SWMS", path: PATH_DASHBOARD.jobsiteSwms },
        { title: "Pool Types", path: PATH_DASHBOARD.poolTypes },
        {
          title: "Construction Types",
          path: PATH_DASHBOARD.constructionTypes,
        },
      ],
    },
  ],
};

// Superadmin sees everything an admin does, plus superadmin-only tools. API
// Keys mints automation credentials (the Claude connector), which is a
// superadmin-only capability — so it lives here, not in the shared adminMenu.
const superAdminMenu = {
  subheader: "Admin",
  items: [
    ...adminMenu.items,
    {
      title: "API Keys",
      path: PATH_DASHBOARD.apiKeys,
      icon: ICONS.apiKeys,
    },
  ],
};

// The sidebar had grown to fifteen top-level entries, which is a list nobody
// reads — it is scanned for the two or three things you actually open, and
// those had drifted to the bottom. So two changes, and they are separate ideas.
//
// ORDER puts the daily work first: who is on site, who you are working with,
// and the documents everyone chases. The registers below it are real but
// occasional.
//
// GROUPS collapses the six safety modules into one parent. They belong
// together, they are opened one at a time, and flat they cost six lines to say
// "safety" once.
//
// This runs on the ALREADY-FILTERED list, and that ordering is load-bearing:
// the sidebar hides items by matching stored top-level titles (onboarding
// gates, per-industry hidden modules), so grouping any earlier would bury a
// title where the filter cannot see it and a cafe would keep being offered
// modules meant for a building site.
const NAV_ORDER = [
  'Overview',
  'Check in',
  'On site now',
  'Contractor',
  'Documents',
  'Job Sites',
];

const NAV_GROUPS = [
  {
    title: 'Safety',
    icon: ICONS.safetyPlanning,
    members: [
      'Action / Hazards',
      'Incidents',
      'Audits & Inspections',
      'Risk Register',
      'Chemical',
      'Safety Planning',
    ],
  },
];

// Kept last because they are settings-shaped, not work-shaped.
const NAV_TAIL = ['People and Training', 'Noticeboard', 'Communication', 'Subscription'];
// Tasks sits right after the Safety group: it is the cross-register due list.

export function groupNav(items: any[]) {
  const remaining = new Map((items || []).map((it) => [it?.title, it]));
  const take = (title: string) => {
    const found = remaining.get(title);
    remaining.delete(title);
    return found;
  };

  const out = NAV_ORDER.map(take).filter(Boolean);

  for (const group of NAV_GROUPS) {
    const children = group.members.map(take).filter(Boolean);
    if (!children.length) continue;
    // A group of one is just that one item wearing a hat — the collapse costs a
    // click and tells the reader nothing.
    if (children.length === 1) {
      out.push(children[0]);
      continue;
    }
    out.push({
      title: group.title,
      path: children[0].path,
      icon: group.icon,
      children: children.map(({ title, path }: any) => ({ title, path })),
    });
  }

  const tail = NAV_TAIL.map(take).filter(Boolean);

  // Anything this function has never heard of still gets shown, in the order it
  // was declared. A new module must not go missing because nobody remembered to
  // name it here.
  return [...out, ...remaining.values(), ...tail];
}

export const menuConfig: Partial<Record<UserRole, { subheader: string; items: any[] }>> = {
  superadmin: superAdminMenu,
  admin: adminMenu,
  builder: {
    subheader: "Builder",

    items: [
      // these are menu items with child menus as well
      {
        title: "Overview",
        path: PATH_DASHBOARD.dash.overview,
        icon: ICONS.dashboard,
      },
      {
        title: "Check in",
        path: PATH_MOBILE.root,
        icon: ICONS.checkIn,
      },
      {
        title: "On site now",
        path: PATH_DASHBOARD.dash.onSiteNow,
        icon: ICONS.onSiteNow,
      },
      {
        title: "Action / Hazards",
        path: PATH_DASHBOARD.dash.actions,
        icon: ICONS.todo,
      },
      {
        title: "Incidents",
        path: PATH_DASHBOARD.dash.incidents,
        icon: ICONS.incidents,
      },
      {
        title: "Tasks",
        path: PATH_DASHBOARD.dash.tasks,
        icon: ICONS.todo,
      },
      {
        title: "Equipment",
        path: PATH_DASHBOARD.dash.equipment,
        icon: ICONS.equipment,
      },
      {
        title: "Audits & Inspections",
        path: PATH_DASHBOARD.dash.inspections,
        icon: ICONS.inspections,
      },
      {
        title: "Risk Register",
        path: PATH_DASHBOARD.dash.risks,
        icon: ICONS.risks,
      },
      {
        title: "People and Training",
        path: PATH_DASHBOARD.dash.training,
        icon: ICONS.training,
        children: [
          { title: "Training", path: PATH_DASHBOARD.dash.training },
        ],
      },
      {
        title: "Chemical",
        path: PATH_DASHBOARD.dash.chemicals,
        icon: ICONS.chemical,
      },
      {
        title: "Safety Planning",
        path: PATH_DASHBOARD.myDocument("whs"),
        icon: ICONS.safetyPlanning,
      },
      {
        title: "Noticeboard",
        path: PATH_DASHBOARD.dash.noticeboard,
        icon: ICONS.noticeboard,
      },
      {
        title: "Documents",
        path: PATH_DASHBOARD.user.profile,
        icon: ICONS.safetyDocs,
        children: [
          { title: "My documents", path: PATH_DASHBOARD.user.profile },
          // Owner-only in the service; shown to everyone because reading what
          // your organisation asks for is not privileged, and the page says so
          // when you cannot edit it.
          { title: "Requirements", path: PATH_DASHBOARD.dash.docRequirements },
        ],
      },
      {
        // Plans and pricing. Owner-side only: an employee has no subscription
        // to change, and their employer's is not theirs to be priced.
        title: "Subscription",
        path: PATH_DASHBOARD.dash.plans,
        icon: ICONS.plans,
      },
      {
        title: "Job Sites",
        path: PATH_DASHBOARD.user.jobsites,
        icon: ICONS.jobsite,
      },
      {
        title: "Document register",
        path: PATH_DASHBOARD.user.documents,
        icon: ICONS.documents,
      },
      {
        title: "Contractor",
        path: PATH_DASHBOARD.user.yourteam,
        icon: ICONS.team,
      },
      {
        title: "Communication",
        path: PATH_DASHBOARD.campaigns.root,
        icon: ICONS.mail,
      },
    ],
  },

  subcontractor: {
    subheader: "Subcontractor",

    items: [
      // these are menu items with child menus as well
      {
        title: "Overview",
        path: PATH_DASHBOARD.dash.overview,
        icon: ICONS.dashboard,
      },
      {
        title: "Check in",
        path: PATH_MOBILE.root,
        icon: ICONS.checkIn,
      },
      // No "On site now" here — the live roster is supervision-side only
      // (builder / supervisor / office admin). Subcontractors and employees
      // check in; they don't monitor who else is on.
      {
        title: "Action / Hazards",
        path: PATH_DASHBOARD.dash.actions,
        icon: ICONS.todo,
      },
      {
        title: "Incidents",
        path: PATH_DASHBOARD.dash.incidents,
        icon: ICONS.incidents,
      },
      {
        title: "Tasks",
        path: PATH_DASHBOARD.dash.tasks,
        icon: ICONS.todo,
      },
      {
        title: "Equipment",
        path: PATH_DASHBOARD.dash.equipment,
        icon: ICONS.equipment,
      },
      {
        title: "Audits & Inspections",
        path: PATH_DASHBOARD.dash.inspections,
        icon: ICONS.inspections,
      },
      {
        title: "Risk Register",
        path: PATH_DASHBOARD.dash.risks,
        icon: ICONS.risks,
      },
      {
        title: "People and Training",
        path: PATH_DASHBOARD.dash.training,
        icon: ICONS.training,
        children: [
          { title: "Training", path: PATH_DASHBOARD.dash.training },
        ],
      },
      {
        title: "Chemical",
        path: PATH_DASHBOARD.dash.chemicals,
        icon: ICONS.chemical,
      },
      {
        title: "Safety Planning",
        path: PATH_DASHBOARD.myDocument("whs"),
        icon: ICONS.safetyPlanning,
      },
      {
        title: "Noticeboard",
        path: PATH_DASHBOARD.dash.noticeboard,
        icon: ICONS.noticeboard,
      },
      {
        title: "Documents",
        path: PATH_DASHBOARD.user.profile,
        icon: ICONS.safetyDocs,
        children: [
          { title: "My documents", path: PATH_DASHBOARD.user.profile },
        // Where you stand with each company you work for. A worker can be
        // employed by two businesses that ask for different documents and
        // verify them separately, so the answer is per company, not global.
        { title: "My companies", path: PATH_DASHBOARD.user.mycompanies },
          // Owner-only in the service; shown to everyone because reading what
          // your organisation asks for is not privileged, and the page says so
          // when you cannot edit it.
          { title: "Requirements", path: PATH_DASHBOARD.dash.docRequirements },
        ],
      },
      {
        // Plans and pricing. Owner-side only: an employee has no subscription
        // to change, and their employer's is not theirs to be priced.
        title: "Subscription",
        path: PATH_DASHBOARD.dash.plans,
        icon: ICONS.plans,
      },
      {
        title: "Job Sites",
        path: PATH_DASHBOARD.user.jobsites,
        icon: ICONS.jobsite,
      },
      {
        title: "Document register",
        path: PATH_DASHBOARD.user.documents,
        icon: ICONS.documents,
      },
      {
        title: "Contractor",
        path: PATH_DASHBOARD.user.yourteam,
        icon: ICONS.team,
      },
    ],
  },

  employee: {
    subheader: "Employee",

    items: [
      // these are menu items with child menus as well
      {
        title: "Overview",
        path: PATH_DASHBOARD.dash.overview,
        icon: ICONS.dashboard,
      },
      {
        title: "Check in",
        path: PATH_MOBILE.root,
        icon: ICONS.checkIn,
      },
      {
        title: "Action / Hazards",
        path: PATH_DASHBOARD.dash.actions,
        icon: ICONS.todo,
      },
      {
        title: "Incidents",
        path: PATH_DASHBOARD.dash.incidents,
        icon: ICONS.incidents,
      },
      {
        title: "Tasks",
        path: PATH_DASHBOARD.dash.tasks,
        icon: ICONS.todo,
      },
      {
        title: "Equipment",
        path: PATH_DASHBOARD.dash.equipment,
        icon: ICONS.equipment,
      },
      {
        title: "Audits & Inspections",
        path: PATH_DASHBOARD.dash.inspections,
        icon: ICONS.inspections,
      },
      {
        title: "Risk Register",
        path: PATH_DASHBOARD.dash.risks,
        icon: ICONS.risks,
      },
      {
        title: "People and Training",
        path: PATH_DASHBOARD.dash.training,
        icon: ICONS.training,
        children: [
          { title: "Training", path: PATH_DASHBOARD.dash.training },
        ],
      },
      {
        title: "Chemical",
        path: PATH_DASHBOARD.dash.chemicals,
        icon: ICONS.chemical,
      },
      {
        title: "Safety Planning",
        path: PATH_DASHBOARD.myDocument("whs"),
        icon: ICONS.safetyPlanning,
      },
      {
        title: "Noticeboard",
        path: PATH_DASHBOARD.dash.noticeboard,
        icon: ICONS.noticeboard,
      },
      {
        title: "Documents",
        path: PATH_DASHBOARD.user.profile,
        icon: ICONS.safetyDocs,
        children: [
          { title: "My documents", path: PATH_DASHBOARD.user.profile },
        // Where you stand with each company you work for. A worker can be
        // employed by two businesses that ask for different documents and
        // verify them separately, so the answer is per company, not global.
        { title: "My companies", path: PATH_DASHBOARD.user.mycompanies },
          // Owner-only in the service; shown to everyone because reading what
          // your organisation asks for is not privileged, and the page says so
          // when you cannot edit it.
          { title: "Requirements", path: PATH_DASHBOARD.dash.docRequirements },
        ],
      },
      {
        title: "Job Sites",
        path: PATH_DASHBOARD.user.jobsites,
        icon: ICONS.jobsite,
      },
      {
        title: "Document register",
        path: PATH_DASHBOARD.user.documents,
        icon: ICONS.documents,
      },
    ],
  },
  officeadmin: {
    subheader: "Office Admin",

    items: [
      // these are menu items with child menus as well
      {
        title: "Overview",
        path: PATH_DASHBOARD.dash.overview,
        icon: ICONS.dashboard,
      },
      {
        title: "On site now",
        path: PATH_DASHBOARD.dash.onSiteNow,
        icon: ICONS.onSiteNow,
      },
      {
        title: "Action / Hazards",
        path: PATH_DASHBOARD.dash.actions,
        icon: ICONS.todo,
      },
      {
        title: "Incidents",
        path: PATH_DASHBOARD.dash.incidents,
        icon: ICONS.incidents,
      },
      {
        title: "Tasks",
        path: PATH_DASHBOARD.dash.tasks,
        icon: ICONS.todo,
      },
      {
        title: "Equipment",
        path: PATH_DASHBOARD.dash.equipment,
        icon: ICONS.equipment,
      },
      {
        title: "Audits & Inspections",
        path: PATH_DASHBOARD.dash.inspections,
        icon: ICONS.inspections,
      },
      {
        title: "Risk Register",
        path: PATH_DASHBOARD.dash.risks,
        icon: ICONS.risks,
      },
      {
        title: "People and Training",
        path: PATH_DASHBOARD.dash.training,
        icon: ICONS.training,
        children: [
          { title: "Training", path: PATH_DASHBOARD.dash.training },
        ],
      },
      {
        title: "Chemical",
        path: PATH_DASHBOARD.dash.chemicals,
        icon: ICONS.chemical,
      },
      {
        title: "Safety Planning",
        path: PATH_DASHBOARD.myDocument("whs"),
        icon: ICONS.safetyPlanning,
      },
      {
        title: "Noticeboard",
        path: PATH_DASHBOARD.dash.noticeboard,
        icon: ICONS.noticeboard,
      },
      {
        title: "Documents",
        path: PATH_DASHBOARD.user.profile,
        icon: ICONS.safetyDocs,
        children: [
          { title: "My documents", path: PATH_DASHBOARD.user.profile },
        // Where you stand with each company you work for. A worker can be
        // employed by two businesses that ask for different documents and
        // verify them separately, so the answer is per company, not global.
        { title: "My companies", path: PATH_DASHBOARD.user.mycompanies },
          // Owner-only in the service; shown to everyone because reading what
          // your organisation asks for is not privileged, and the page says so
          // when you cannot edit it.
          { title: "Requirements", path: PATH_DASHBOARD.dash.docRequirements },
        ],
      },
      {
        title: "Job Sites",
        path: PATH_DASHBOARD.user.jobsites,
        icon: ICONS.jobsite,
      },
      {
        title: "Document register",
        path: PATH_DASHBOARD.user.documents,
        icon: ICONS.documents,
      },
      {
        title: "Contractor",
        path: PATH_DASHBOARD.user.yourteam,
        icon: ICONS.team,
      },
      {
        title: "Communication",
        path: PATH_DASHBOARD.campaigns.root,
        icon: ICONS.mail,
      },
    ],
  },
  supervisor: {
    subheader: "Supervisor",

    items: [
      // these are menu items with child menus as well
      {
        title: "Overview",
        path: PATH_DASHBOARD.dash.overview,
        icon: ICONS.dashboard,
      },
      {
        title: "Check in",
        path: PATH_MOBILE.root,
        icon: ICONS.checkIn,
      },
      {
        title: "On site now",
        path: PATH_DASHBOARD.dash.onSiteNow,
        icon: ICONS.onSiteNow,
      },
      {
        title: "Action / Hazards",
        path: PATH_DASHBOARD.dash.actions,
        icon: ICONS.todo,
      },
      {
        title: "Incidents",
        path: PATH_DASHBOARD.dash.incidents,
        icon: ICONS.incidents,
      },
      {
        title: "Tasks",
        path: PATH_DASHBOARD.dash.tasks,
        icon: ICONS.todo,
      },
      {
        title: "Equipment",
        path: PATH_DASHBOARD.dash.equipment,
        icon: ICONS.equipment,
      },
      {
        title: "Audits & Inspections",
        path: PATH_DASHBOARD.dash.inspections,
        icon: ICONS.inspections,
      },
      {
        title: "Risk Register",
        path: PATH_DASHBOARD.dash.risks,
        icon: ICONS.risks,
      },
      {
        title: "People and Training",
        path: PATH_DASHBOARD.dash.training,
        icon: ICONS.training,
        children: [
          { title: "Training", path: PATH_DASHBOARD.dash.training },
        ],
      },
      {
        title: "Chemical",
        path: PATH_DASHBOARD.dash.chemicals,
        icon: ICONS.chemical,
      },
      {
        title: "Safety Planning",
        path: PATH_DASHBOARD.myDocument("whs"),
        icon: ICONS.safetyPlanning,
      },
      {
        title: "Noticeboard",
        path: PATH_DASHBOARD.dash.noticeboard,
        icon: ICONS.noticeboard,
      },
      {
        title: "Documents",
        path: PATH_DASHBOARD.user.profile,
        icon: ICONS.safetyDocs,
        children: [
          { title: "My documents", path: PATH_DASHBOARD.user.profile },
        // Where you stand with each company you work for. A worker can be
        // employed by two businesses that ask for different documents and
        // verify them separately, so the answer is per company, not global.
        { title: "My companies", path: PATH_DASHBOARD.user.mycompanies },
          // Owner-only in the service; shown to everyone because reading what
          // your organisation asks for is not privileged, and the page says so
          // when you cannot edit it.
          { title: "Requirements", path: PATH_DASHBOARD.dash.docRequirements },
        ],
      },
      {
        title: "Job Sites",
        path: PATH_DASHBOARD.user.jobsites,
        icon: ICONS.jobsite,
      },
      {
        title: "Contractor",
        path: PATH_DASHBOARD.user.yourteam,
        icon: ICONS.team,
      },
    ],
  },
};
